import React from 'react';
import styled from 'styled-components';

const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
  background: #F5F7FA;
`;

const Card = styled.div`
  background: #fff;
  border-radius: 6px;
  padding: 40px;
  box-shadow: 0 1px 4px rgba(0, 66, 66, 0.06);
  text-align: center;
  max-width: 420px;
`;

const Title = styled.h2`
  font-family: 'Nunito Sans', sans-serif;
  font-size: 18px;
  font-weight: 700;
  color: #004242;
  margin-bottom: 8px;
`;

const Message = styled.p`
  font-family: 'Nunito Sans', sans-serif;
  font-size: 14px;
  color: #64748b;
  margin-bottom: 20px;
`;

const ReloadButton = styled.button`
  padding: 10px 24px;
  background: #0291EF;
  color: #fff;
  border: none;
  border-radius: 4px;
  font-family: 'Nunito Sans', sans-serif;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  &:hover { opacity: 0.9; }
`;

export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    console.error('ErrorBoundary caught:', error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <Container>
          <Card>
            <Title>Bir hata oluştu</Title>
            <Message>Beklenmeyen bir hata meydana geldi. Sayfayı yeniden yükleyerek devam edebilirsiniz.</Message>
            <ReloadButton onClick={() => window.location.reload()}>
              Sayfayı Yenile
            </ReloadButton>
          </Card>
        </Container>
      );
    }
    return this.props.children;
  }
}
